import * as React from 'react';

import { AppNavigatorParamsContext } from '@/lib/navigation';
import { UserInfoContext } from '../user/user-info';
import { OnboardingInfoContext } from './onboarding-info';
import { NavigationPaneRouteParamsContext } from '../../../lib/navigation/navigation-pane-route-params.context';

export const OnboardingContextHOC = (Component:React.ComponentType) => (props) => {
  const { onboarding } = React.useContext(UserInfoContext);
  const params = React.useContext(AppNavigatorParamsContext);
  const { ticket } = React.useContext(NavigationPaneRouteParamsContext);

  const isRedirectToOnboarding = params && params.onboarding === 'true';
  const isRenderOnboardingTicketView = isRedirectToOnboarding && !ticket;

  return (
    <OnboardingInfoContext.Provider value={{
      isRenderOnboardingTicketView,
      onboarding,
    }}
    >
      <Component {...props} />
    </OnboardingInfoContext.Provider>
  );
};
